module.exports = __webpack_public_path__ + "media/laser.2910c74e.mp3";